import { AnimatePresence, motion } from "framer-motion";

interface ThanksForFeedbackMessageProps {
  visible: boolean;
  message?: string;
  className?: string;
}

export function ThanksForFeedbackMessage({
  visible,
  message = "Obrigado pelo feedback!",
  className = "",
}: ThanksForFeedbackMessageProps) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.span
          key="feedback"
          initial={{ opacity: 0, y: -4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -4 }}
          transition={{ duration: 0.2 }}
          className={`text-sm flex-initial text-muted-foreground ml-2 mt-1 ${className}`}
        >
          {message}
        </motion.span>
      )}
    </AnimatePresence>
  );
}
